export default __webpack_public_path__ + "static/circle-ch-flag-b357d7242ef202b9f48e206b8685cff2.svg";